<template>
  <div></div>
</template>

<script>
export default {
  name: 'MilkGoodsDetailPage'
}
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/milk/goods/MilkGoodsDetailPage.vue